import Joi from "joi";

export const modelDetailsSchema = Joi.object({
  modelName: Joi.string().required().messages({
    "string.empty": "Model name is required.",
    "string.required": "Model name is required.",
  }),
  gender: Joi.number().integer().required().messages({
    "number.base": "Gender must be Male or Female.",
    "any.required": "Gender is required",
  }),
  sType: Joi.string().required().messages({
    "string.empty": "Model type is required.",
    "string.required": "Model type is required.",
  }),
  modelImage: Joi.any().required().not(null).empty().messages({
    "any.required": "Model Image is required.",
    "any.empty": "Model Image is required.",
    "any.only": "Model Image is required.",
    "any.invalid": "Model Image is required",
  }),
});
